import React from 'react'
import styles from './ModalNoNumberView.module.scss'
import ChangeModal from './changeModal'
import Icon from '../../../../../assets/images/invoice/icon_fifth.svg'
import ModalButton from 'spa/member/components/ModalButton'

const NoNumberView: React.FC<ChangeModal> = (props) => {
  return (
    <div className={`${styles.overlay} js-modal-overlay`}>
      <div className={`${styles.modalContainer} js-modal-container`}>
        <div className={styles.invoiceIcon}><img src={Icon} /></div>
        <div className={styles.sectionTitle}><p>ご回答ありがとうございます。</p></div>
        <div className={styles.sectionText}>
          <p>インボイス登録番号はマイページメニューより登録できます。ご回答ありがとうございました。</p>
        </div>
        <div className={styles.sectionBtn}>
          <ModalButton buttonType='NEXT' onClick={() => props.changeModal('')}>閉じる</ModalButton>
        </div>
      </div>
    </div>
  )
}

export default NoNumberView
